import { reducer } from './store'
// import modals from './modals'
// import { ChapterView, EndtestView } from './views'

// export { ChapterView as QuizView }
export { initialState } from './store/reducer'

// export const routes = {
//   endtest: `/eindtoets`,
//   'endtest-summary': `/eindtoets/summary`,
//   'endtest-question': `/eindtoets/:question`,
// }

// export const routeToInstall = {
//   id: 'endtest',
//   path: routes.endtest,
//   component: EndtestView,
// }

export const storeToInstall = reducer
// export const modalToInstall = modals
